var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSuccess = function SvgIconSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97363 0C3.56923 0 0 3.57017 0 7.97363C0 12.3776 3.56967 15.9473 7.97363 15.9473C12.3771 15.9473 15.9468 12.3776 15.9468 7.97363C15.9468 3.57068 12.3771 0 7.97363 0ZM7.97363 14.4522C4.39548 14.4522 1.49508 11.5518 1.49508 7.97363C1.49508 4.39548 4.39599 1.49508 7.97363 1.49508C11.5513 1.49508 14.4517 4.39548 14.4517 7.97363C14.4517 11.5518 11.5513 14.4522 7.97363 14.4522ZM10.1405 4.85095C10.3353 4.49962 10.7684 4.37954 11.1073 4.58185C11.4462 4.78467 11.5623 5.23367 11.3675 5.58562L8.29865 11.0979C8.03586 11.5681 7.43449 11.4701 7.3655 11.4589C7.36371 11.4586 7.36228 11.4583 7.36123 11.4582L7.34227 11.4572L7.34077 11.4542C7.15585 11.4198 6.97895 11.2991 6.82397 11.0978L4.75183 8.57567C4.53252 8.26269 4.67256 7.77477 5.01146 7.57196C5.34985 7.36964 5.70815 7.53059 5.97776 7.84106L7.46682 9.65357L10.1405 4.85095Z",
    fill: "#3DB39E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-success.ad7aad83.svg";
export { ForwardRef as ReactComponent };